import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MySoundOn } from './img/sound-on.svg'

type SoundOnProps = IconWrapperProps

export const SoundOnIcon: FC<SoundOnProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MySoundOn />
    </IconWrapper>
  )
}
